import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { makeChampion } from './types';

import { requestMakeChampionSuccess, requestMakeChampionFailure } from './actions';

const logger = new Logger('Saga:Team:MakeChampion');

export function* requestMakeChampionReducer(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.put,
      routerService.generate('api.teams.make_champion', {
        teamId: action.teamId,
        teamMemberId: action.teamMemberId,
      }),
    );

    yield put(requestMakeChampionSuccess(response.data));
  } catch (error) {
    logger.error('Failed to make user champion with the following error', error);
    yield put(requestMakeChampionFailure(error));
  }
}

export default function* makeChampionSaga() {
  return yield all([takeLatest(makeChampion.request, requestMakeChampionReducer)]);
}
